import React from "react";
import PropTypes from "prop-types";
import Pages from "@client.enums/pages";
import ProfileMenu from "@client.components/ProfileMenu";
import { NavImgLink } from "@client.components/NavImgLink/NavImgLink";
import DemoBadge from "@client.components/DemoBadge";
import "./TopBar.scss";

export const TopBar = ({ title }) => {
  return (
    <div className="top-bar" data-testid="TopBar">
      <div className="title-container">
        <div className="title">{title}</div>
        <DemoBadge />
      </div>
      <div className="right-btns">
        <NavImgLink
          icon="settings"
          showTitle={false}
          translationKey="components.TopBar.settings"
          url={Pages.UsersManagement}
        />
        <ProfileMenu />
      </div>
    </div>
  );
};

TopBar.propTypes = {
  title: PropTypes.string,
};
